import spreadsheetsApiClient from '../../lib/spreadsheetsApiClient';
import checkExerciseCompleted from './checkExerciseCompleted';
import checkExerciseRequested from './checkExerciseRequested';
const checkExercise = (exerciseId, environment) => async dispatch => {
  dispatch(checkExerciseRequested(exerciseId));
  const result = await spreadsheetsApiClient(environment).checkExercise(exerciseId);
  dispatch(checkExerciseCompleted(exerciseId, result.success, result.message));
};
export default checkExercise;